import { useQuery } from '@tanstack/react-query';
import { vehicleOptions } from '../../constants/vehicles';
export function useVehicles(filter, scope) {
    const { data, isLoading, isSuccess } = useQuery(vehicleOptions.get(filter, scope));
    return {
        vehicles: data ?? [],
        loadingVehicles: isLoading,
        isSuccess,
    };
}
